import { Injectable } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {CustomNotificationService} from "./custom-notification.service";
import {ConflictModel} from "../../models/conflict.model";
import {SafeUpdateService} from "./safe-update.service";

@Injectable({
  providedIn: 'root'
})
export class HttpErrorsService {

  constructor(private translate: TranslateService,
              private notificationService: CustomNotificationService,
              private safeUpdateService: SafeUpdateService) { }

  // handleError(error: HttpErrorResponse): {rootConflict: ConflictModel, model: any} | null {
  handleError(error: HttpErrorResponse,
              submitCallback: ((serverResource: any, overrideValues?: { [key: string]: any }) => void) | null = null) {
    if(error.status === 409 &&
      error.error?.conflicts &&
      error.error?.model &&
      submitCallback
    ) {
      let rootConflict: ConflictModel = error.error?.conflicts
      let model = error.error?.model

      this.notificationService.error('ERRORS.UPDATE_CONFLICT')

      let modalRef = this.safeUpdateService.openModal(rootConflict);

      // Subscribe to the modal close event
      modalRef.onClose.subscribe((response: { [key: string]: any } | undefined) => {
        if (!response) {
          // Override server with all local changes
          submitCallback(model);
        } else {
          // Override server with selected local changes
          submitCallback(model, response);
        }
      });

      return
    }

    if (error.error?.errors) {
      const errors = error.error.errors;

      // Backend sendet bei Odoo-Fehlern (z. B. ungültige VAT-ID) eine konkrete message – diese anzeigen
      if (error.error?.message && typeof error.error.message === 'string') {
        this.notificationService.error(error.error.message, true, 8000);
        return;
      }

      Object.keys(errors).forEach((key) => {
        const errorValue = errors[key];

        // Check if the error is an array (validation error)
        if (Array.isArray(errorValue)) {
          errorValue.forEach((errorType: string) => {
            let errorKey = `ERRORS.${errorType}`;
            let fieldKey = `FIELDS.${key}`;

            this.translate.get([errorKey, fieldKey]).subscribe((translations: any) => {
              const translatedError = translations[errorKey].replace('{{ field }}', translations[fieldKey]);
              this.notificationService.error(translatedError);
            });
          });
        } else {
          // Handle specific logic errors (like credentialsIncorrect)
          let errorKey = `ERRORS.${key}.${errorValue}`;

          this.translate.get(errorKey).subscribe((translatedError: string) => {
            this.notificationService.error(translatedError);
          });
        }
      });
    } else {
      this.notificationService.error('ERRORS.general');
    }

    return null
  }
}
